// @noflow
import { Icon, InfoBar, Item, Temp } from './styles';

import { curry, every, flowRight, identity } from 'lodash/fp';
import { get } from '~/core/utils/immutable';
import { HubClock } from '~/components/widgets';
import iconMap from './icons';
import * as React from 'react';

const replaceNullWithDefault = curry((def, value) => value || def);
const replace = curry((regEx, replacement, string) => string.replace(regEx, replacement));

const getWeatherIcon = flowRight(
    value => iconMap[value],
    replace(/^(day|night)_/, ''),
    replaceNullWithDefault('sunny'),
    get('icon')
);

const MaybeRender = ({ children, ...conditions }) => (every(identity, conditions) ? children : null);

export default ({ hubDateTime, weather }) => {
    const temperature = weather.getIn(['temperature', 'value']);

    const iconName = getWeatherIcon(weather);
    return (
        <InfoBar>
            <MaybeRender hubDateTime={hubDateTime}>
                <Item>
                    <HubClock hubDateTime={hubDateTime} />
                </Item>
            </MaybeRender>
            <MaybeRender iconName={iconName} temp={temperature !== undefined}>
                <Item>
                    <Icon type={iconName} />
                    <Temp value={temperature} />
                </Item>
            </MaybeRender>
        </InfoBar>
    );
};



// WEBPACK FOOTER //
// ./src/components/widgets/info-bar/index.js